<template>
<div class="VstudentCard">
   <!-- v-if="studentList.length>0" -->
 <div class="center">
      <div v-if="isStatus" class="isStatusClass">
          <img v-if="+studentInfo.status==0" src="@/assets/image/待审核.png" alt="" width="100">
          <img v-if="+studentInfo.status==1" src="@/assets/image/已审核.png" alt=""  width="100">
          <img v-if="+studentInfo.status==2" src="@/assets/image/审核不通过.png" alt=""  width="100">
      </div>
        <van-row  gutter="10" style="padding-bottom:5px;">
        <van-col span="6" @click="showUserDialog =true">
          <van-image v-if="studentInfo.sex=='男'" width="95%"  :src="require('@/assets/parentImg/制证男.png')" rel="external nofollow" />
          <van-image v-if="studentInfo.sex=='女'" width="95%"  :src="require('@/assets/parentImg/制证女.png')" rel="external nofollow" />
          <van-image v-if="!studentInfo.sex" width="95%"  :src="require('@/assets/parentImg/制证男.png')" rel="external nofollow" />
            <!--  -->
        </van-col>
<van-dialog v-model:show="showUserDialog" width="80%" title="提 示" :show-confirm-button='false' >
  <div style="padding:10px;text-align: left;font-size: 4vw;">
    <p>为保障青少年肖像隐私，</p>
    <p>平台所有证件照片均已进行特征数字转译，</p>
    <p>原图像已彻底删除无法还原。</p>
  </div>
<van-button round  style="width:85%;margin:10px 0;"  color="linear-gradient(to right, #ff6034, #ee0a24)" @click="showUserDialog = false">
  确 定
</van-button>
</van-dialog>
        <van-col span="5"  class="text_l" style="color:#999;">
             <div >姓 &nbsp;&nbsp; 名 </div>
            <!-- <div>性别：    </div> -->
            <div>出生日期</div>
            <div>所在学校</div>
            <div>所在班级</div>
            <!-- <div>学 &nbsp;&nbsp; 号</div> -->
        </van-col>

        <van-col span="13" class="text_l">
            <div><span class="center_value">{{studentInfo.studentName||''}}</span>

          <van-popover v-model="showPopover" theme="dark" trigger="click" :actions="studentList" @select="onSelectPopover">
            <template #reference>
              <van-icon name="exchange" class="onchangeClass" v-if="isChange"/>
            </template>
          </van-popover>

            </div>
            <!-- <div><span  class="center_value">{{studentInfo.sex||''}}</span></div> -->
            <div><span  class="center_value">{{studentInfo.birthDay||''}}</span></div>
            <div class="center_value">{{studentInfo.schoolName||''}}</div>
            <div><span  class="center_value">{{studentInfo.studentGradeName}}{{studentInfo.className||studentInfo.adminClassName||''}}</span></div>
            <!-- <div> <span  class="center_value">{{studentInfo.snCode||''}}</span></div> -->
        </van-col>

        
        </van-row>
          <!-- <div @click="onshowQr(studentInfo)" style="margin-top:5px;text-align: right;">
                <vue-qr :dotScale='0.55'  colorDark="#000" colorLight="#fafafa" :text="studentInfo.snCode+'&&'+studentInfo.schoolCode"  :size="55" :margin='2' ></vue-qr>
          </div> -->

        
    </div>
    <van-popup v-model:show="showQRDialog" width="80%"  get-container="body" >
  <div >
  <vue-qr :dotScale='0.55'  colorDark="#000" colorLight="#fafafa" style="margin: 0 atuo;" :text="studentInfo.snCode+'&&'+studentInfo.schoolCode"   :margin='8'></vue-qr>
  </div>
</van-popup>
</div>
</template>
<script>
import { getChildInfoBySnCode,getStudentInfoBySnCode} from "@/api/common.js";
import vueQr from 'vue-qr'
import { getChildInfoList} from "@/api/studentBind.js";
export default {
  name: 'VstudentCard',
  components: {vueQr},
 
  props: {
  // 文本
    icon: {
      type: String,
      default: '',
    },
    
    snCode: {
      type: String,
      default: "",
    },
     schoolCode: {
      type: String,
      default: "",
    },
    // 当已有学生信息的时候可以选择传入学生信息
    propsStudentInfo: {
      type: Object,
      default: ()=>{},
    },
    // 是否显示审核状态
    isStatus:{
      type: Boolean,
      default: false,
    },
    // 是否显示切换按钮
    isChange:{
      type: Boolean,
      default: false,
    },
    // 是否是教师端使用
    teacher:{
      type: Boolean,
      default: false,
    }
    
  },

  watch:{
    snCode:{
          immediate: true,
      handler: async function(val) {
        console.log(val);
            if (val&&val!=='') {
            console.log(val);
              if (this.teacher) {
                this.getStudentInfoBySnCode()
              }else{
                this.getChildInfoBySnCode()
              }
            }
    }
        
    },
    propsStudentInfo:{
          immediate: true,
      handler: async function(val) {
        console.log(val);
            if (val&&val!==''&&!this.snCode&&this.snCode=='') {
            console.log(val);
            this.studentInfo =val
            }
      }
    },
  },
  data() {
    return {
        showQRDialog:false,
      showUserDialog:false,

        studentInfo:{
            snCode:''
        },
        studentList:[],
        showPopover:false
    }
  },

  created() {

  },
  mounted () {
    // this.getChildInfoList()
  },
  methods: {
    onSelectPopover(action){
      console.log(action);
    this.studentInfo = action
    },
        getChildInfoList(){
getChildInfoList({
  status:'-1'
}).then(res=>{
    res.data.data?.forEach(el=>{
      this.$set(el,'text', el.studentName)
  })
  this.studentList = res.data.data
    this.studentInfo = this.studentList[0]
  
})
    },
      onshowQr(item){
      console.log(1);
      this.showQRDialog =true
    },
    getChildInfoBySnCode(){
getChildInfoBySnCode({
    snCode:this.snCode,
    schoolCode:this.schoolCode,
}).then(res=>{
console.log(res);
this.studentInfo =res.data.body
})
    },
    getStudentInfoBySnCode(){
getStudentInfoBySnCode({
    snCode:this.snCode,
    schoolCode:this.schoolCode,
}).then(res=>{
console.log(res);
this.studentInfo =res.data.body
})
    },
   buttonCustomClick() {
    this.$emit("click");
  }
  },
}
</script>

<style lang="less" scoped>
  .VstudentCard {


    .center{
        // height: 290px;
        padding:10px;
        position: relative;
        background-color: #fff;
        border-radius: 10px;
        margin:0 10px;
        // box-shadow: 2px 2px 3px 3px rgba(226, 225, 225, 0.6);
        background-image: url('../assets/background/studentCardBGI.png');
    background-repeat: no-repeat;
    background-size: 100%;
        .isStatusClass{
          position: absolute;
          right: 30px;
          top: 10px;
          // transform: rotate(45deg);
        }
        .onchangeClass{
          font-size: 15px;
          font-weight: 600;
          margin-left: 50px;
        }
        .center_value{
            color: #1A1A1A;
            font-weight: normal;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            width: 100%;


        }
        .center_footer{
            text-align: left;
            .center_footer_title{
                font-size: 20px;
                font-weight: normal;
            }
            
            .center_footer_left{

            }
            .center_footer_right{
                .center_footer_right_value{
                font-size: 20px;
                height: 50px;
                line-height: 50px;
                border: 1px solid #bbb;
                margin-top: 10px;
                text-align: center;

            }
            }
            .center_footer_delete{
              line-height: 100px;
              font-size: 35px;
              text-align: center;
            }
        }
    }
    .text_l{
    text-align: left;
    text-overflow:ellipsis;
    overflow:hidden;
    line-height: 12px;
    font-size: 3.3vw;
    div{
      height: 6vw;
      line-height: 6vw;
    }
    // white-space:nowrap;
    
    
}
.text_c{
    text-align: center;
}
  }


</style>
